export default __webpack_public_path__ + "static/media/Design PhD.675dd2a7.pdf";